import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { FreetextOptions } from '../modal.model';

@Component({
  selector: 'sb-freetext-modal',
  templateUrl: './sb-freetext-modal.component.html',
  styleUrls: ['./sb-freetext-modal.component.scss'],
  standalone: false,
})
export class SbFreetextModalComponent implements OnInit {
  options: FreetextOptions<string>;
  @Input()
  templateId: string;
  selectedOption: string;
  isPatternMatched = true;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as FreetextOptions<string>;
    this.selectedOption = this.options.initial;
    this.checkPattern();
  }

  constructor(private state: SbModalState) {}

  ok() {
    if (this.checkOkEnabled()) {
      this.state.modals.get(this.templateId).close({ value: this.selectedOption, cancel: false });
    }
  }

  checkOkEnabled() {
    return true;
    /* TODO check if code needed here
    if (this.selectedOption) {
      return this.selectedOption !== null;
    }
    return false;*/
  }

  cancel() {
    this.state.modals.get(this.templateId).close({ value: null, cancel: true });
  }

  checkPattern() {
    if (!this.options.regex) {
      return;
    }
    const pattern = new RegExp(this.options.regex);
    this.isPatternMatched = pattern.test(this.selectedOption);
  }
}
